var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2168_3317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3518 3.97373C12.6602 3.66539 12.8335 3.24717 12.8336 2.81106C12.8336 2.37495 12.6604 1.95668 12.3521 1.64827C12.0437 1.33985 11.6255 1.16656 11.1894 1.1665C10.7533 1.16645 10.335 1.33964 10.0266 1.64798L2.24145 9.43489C2.10602 9.56993 2.00585 9.7362 1.94979 9.91906L1.1792 12.4577C1.16413 12.5082 1.16299 12.5618 1.17591 12.6128C1.18883 12.6638 1.21532 12.7104 1.25259 12.7476C1.28985 12.7848 1.33648 12.8113 1.38755 12.8241C1.43861 12.8369 1.4922 12.8357 1.54262 12.8206L4.08187 12.0506C4.26455 11.995 4.43081 11.8954 4.56604 11.7606L12.3518 3.97373Z",
    stroke: "currentColor",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.9165L11.0833 5.24984",
    stroke: "currentColor",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_3317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.844c5ff9cb34328e0d64b385f3e10bdb.svg";
export { ForwardRef as ReactComponent };